import { render } from "./ServiceCategoryImaging.vue?vue&type=template&id=a656e2ae&ts=true"
import script from "./ServiceCategoryImaging.vue?vue&type=script&lang=ts"
export * from "./ServiceCategoryImaging.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__